module.exports = __webpack_public_path__ + "static/img/fw.be8239f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/fw.jpg
// module id = 7dL+
// module chunks = 1